import { INITIAL_END_VALUE } from './constants';
export function getClassName({
  indx,
  totalCount,
  activeIndex,
  start,
  end,
}: {
  indx: number;
  totalCount: number;
  activeIndex: number;
  start: number;
  end: number;
}) {
  if (activeIndex === indx) {
    return 'active';
  }
  if (
    totalCount > INITIAL_END_VALUE &&
    !(activeIndex === indx || activeIndex === indx + 1 || activeIndex === indx - 1) &&
    (indx === start || indx === end - 1)
  ) {
    return 'small';
  }
  return '';
}

export const getBasicDotsValues = (width: number) => {
  const translateBy = 2 * width - 1; //slide the dots for actual dot length+ margin (length of dot -1) px
  const dotDimensions = width; //actual width of dot
  const containerWidth = translateBy * 5; //this is the width of container. each (dot+ margin) times five(numbe rof dots)
  return {
    translateBy,
    dotDimensions,
    containerWidth,
  };
};
